import { Extension } from '@tiptap/core';
import { NodeAlign } from '../../types/enums';

export interface TextAlignOptions {
  types: string[];
  alignments: string[];
  defaultAlignment: string;
}

const getElementAlignment = (element: HTMLElement): string | undefined => {
  const classes = element.classList.values();

  for (const value of classes) {
    if (
      [NodeAlign.Left, NodeAlign.Center, NodeAlign.Right, NodeAlign.Justify].includes(
        value as NodeAlign
      )
    ) {
      return value;
    }
  }

  return undefined;
};

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    align: {
      /**
       * Set the text align attribute
       * @param align The alignment
       * @example editor.commands.setTextAlign('left')
       */
      setTextAlign: (align: string) => ReturnType;
    };
  }
}

export const TextAlign = Extension.create<TextAlignOptions>({
  name: 'text-align',

  addOptions() {
    return {
      types: [],
      alignments: [NodeAlign.Left, NodeAlign.Center, NodeAlign.Right, NodeAlign.Justify],
      defaultAlignment: NodeAlign.Left,
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          align: {
            default: this.options.defaultAlignment,
            parseHTML: element => getElementAlignment(element) || this.options.defaultAlignment,
            renderHTML: attributes => ({ class: attributes.align }),
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setTextAlign:
        (align: string) =>
        ({ commands }) => {
          if (!this.options.alignments.includes(align)) {
            return false;
          }

          return this.options.types
            .map(type => commands.updateAttributes(type, { align }))
            .every(response => response);
        },
    };
  },
});
